/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Profession = {
  type: 'Enum',
} as const;
